import { createContext } from "react"
import { TreeProps } from "./Tree"

interface TreeContextProps {
  nDelete: NonNullable<TreeProps["n_delete"]>
  nCopy: NonNullable<TreeProps["n_copy"]>
  nEdit: NonNullable<TreeProps["n_edit"]>
  nMove: NonNullable<TreeProps["n_move"]>
  nCreate: NonNullable<TreeProps["n_create"]>
  nCustom: NonNullable<TreeProps["n_custom"]>
  columns: TreeProps["columns"]
  moveDirection: NonNullable<TreeProps["move_direction"]>
  levelClassName: NonNullable<TreeProps["level_className"]>
  enableEdit: TreeProps["enable_edit"]
  enableCopy: TreeProps["enable_copy"]
  enableDelete: TreeProps["enable_delete"]
  enableMultiSelect: TreeProps["enable_multi_select"]
  selectedId: TreeProps["selected_id"]
  matchedIds: number[]
  expandedIds: number[]
}

export const TreeContext = createContext<TreeContextProps>({
  nDelete: 0,
  nCopy: 0,
  nEdit: 0,
  nMove: 0,
  nCreate: 0,
  nCustom: 0,
  columns: undefined,
  moveDirection: "right",
  levelClassName: {},
  enableEdit: undefined,
  enableCopy: undefined,
  enableDelete: undefined,
  enableMultiSelect: undefined,
  selectedId: undefined,
  matchedIds: [],
  expandedIds: [],
})
